module.exports = __webpack_public_path__ + "img/img-4999ca.jpg";